const workflows = {
  title: "Workflows",
  start: "Start Workflow",
  saved: "Workflow saved",
  deleted: "Workflow deleted",
  empty: "There are no workflows available.",
};
export default workflows;
